import { render } from "./RegisterProgram.vue?vue&type=template&id=1a76af58&scoped=true"
import script from "./RegisterProgram.vue?vue&type=script&lang=js"
export * from "./RegisterProgram.vue?vue&type=script&lang=js"

import "./RegisterProgram.vue?vue&type=style&index=0&id=1a76af58&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a76af58"]])

export default __exports__